import { Card, Col, Row } from 'antd';
import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";

import AddDetails from './addDetails';
import CompanySettingDetails from './getAllCompanyDetail';

const CompanyDetails = (props) => {

  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prevKey => prevKey + 1); // Increment key to trigger re-render
  };


	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		
		<>
	<PageTitle title='Back' />
    <Row gutter={16} className='mt-1'>
      <Col span={8}>
        <Card title="Add Company Details" >
          <AddDetails onUpdate={handleRefresh}/>
        </Card>
      </Col>
      <Col span={16}>
        <Card title="Company Settings List">
          <CompanySettingDetails key={refreshKey}/>
        </Card>
      </Col>
    </Row>
	</>
	);
};

export default CompanyDetails;
